import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListBorderosForCarrierQueryVariables = Types.Exact<{
  request: Types.BorderoEdpFilter;
}>;


export type ListBorderosForCarrierQuery = { __typename?: 'Query', listBorderosForCarrier?: { __typename?: 'GenericEntityListBorderoEdpData', rawType?: any | null, type?: any | null, entity?: Array<{ __typename?: 'BorderoEdpData', borderoNumber?: string | null, borderoDate?: string | null, borderoPosition?: string | null, countPosition?: number | null, carrierNumber?: string | null, carrierName?: string | null, orderArea?: string | null, relation?: string | null, goodsCategory?: string | null, status?: string | null, loadNumber?: string | null, consignee?: string | null, consignor?: string | null, fsdNumber?: string | null, volume?: number | null, weight?: number | null }> | null } | null };

export type GetUploadDocumentsForBorderoQueryVariables = Types.Exact<{
  request: Types.BorderoUploadDocumentsQueryInput;
}>;


export type GetUploadDocumentsForBorderoQuery = { __typename?: 'Query', getUploadDocumentsForBordero?: Array<{ __typename?: 'BorderoUploadDocument', carrierNumber?: string | null, borderoNumber?: string | null, borderoDate?: string | null, borderoPosition?: string | null, orderArea?: string | null, relation?: string | null, goodsCategory?: string | null, loadNumber?: string | null, consignee?: string | null, consignor?: string | null, volume?: number | null, weight?: number | null, status?: string | null }> | null };


export const ListBorderosForCarrierDocument = gql`
    query listBorderosForCarrier($request: BorderoEdpFilter!) {
  listBorderosForCarrier(request: $request) {
    rawType
    type
    entity {
      borderoNumber
      borderoDate
      borderoPosition
      countPosition
      carrierNumber
      carrierName
      orderArea
      relation
      goodsCategory
      status
      loadNumber
      consignee
      consignor
      fsdNumber
      volume
      weight
    }
  }
}
    `;

/**
 * __useListBorderosForCarrierQuery__
 *
 * To run a query within a React component, call `useListBorderosForCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBorderosForCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBorderosForCarrierQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useListBorderosForCarrierQuery(baseOptions: Apollo.QueryHookOptions<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables> & ({ variables: ListBorderosForCarrierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables>(ListBorderosForCarrierDocument, options);
      }
export function useListBorderosForCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables>(ListBorderosForCarrierDocument, options);
        }
// @ts-ignore
export function useListBorderosForCarrierSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables>): Apollo.UseSuspenseQueryResult<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables>;
export function useListBorderosForCarrierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables>): Apollo.UseSuspenseQueryResult<ListBorderosForCarrierQuery | undefined, ListBorderosForCarrierQueryVariables>;
export function useListBorderosForCarrierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables>(ListBorderosForCarrierDocument, options);
        }
export type ListBorderosForCarrierQueryHookResult = ReturnType<typeof useListBorderosForCarrierQuery>;
export type ListBorderosForCarrierLazyQueryHookResult = ReturnType<typeof useListBorderosForCarrierLazyQuery>;
export type ListBorderosForCarrierSuspenseQueryHookResult = ReturnType<typeof useListBorderosForCarrierSuspenseQuery>;
export type ListBorderosForCarrierQueryResult = Apollo.QueryResult<ListBorderosForCarrierQuery, ListBorderosForCarrierQueryVariables>;
export const GetUploadDocumentsForBorderoDocument = gql`
    query getUploadDocumentsForBordero($request: BorderoUploadDocumentsQueryInput!) {
  getUploadDocumentsForBordero(request: $request) {
    carrierNumber
    borderoNumber
    borderoDate
    borderoPosition
    orderArea
    relation
    goodsCategory
    loadNumber
    consignee
    consignor
    volume
    weight
    status
  }
}
    `;

/**
 * __useGetUploadDocumentsForBorderoQuery__
 *
 * To run a query within a React component, call `useGetUploadDocumentsForBorderoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadDocumentsForBorderoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadDocumentsForBorderoQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetUploadDocumentsForBorderoQuery(baseOptions: Apollo.QueryHookOptions<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables> & ({ variables: GetUploadDocumentsForBorderoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables>(GetUploadDocumentsForBorderoDocument, options);
      }
export function useGetUploadDocumentsForBorderoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables>(GetUploadDocumentsForBorderoDocument, options);
        }
// @ts-ignore
export function useGetUploadDocumentsForBorderoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables>;
export function useGetUploadDocumentsForBorderoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadDocumentsForBorderoQuery | undefined, GetUploadDocumentsForBorderoQueryVariables>;
export function useGetUploadDocumentsForBorderoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables>(GetUploadDocumentsForBorderoDocument, options);
        }
export type GetUploadDocumentsForBorderoQueryHookResult = ReturnType<typeof useGetUploadDocumentsForBorderoQuery>;
export type GetUploadDocumentsForBorderoLazyQueryHookResult = ReturnType<typeof useGetUploadDocumentsForBorderoLazyQuery>;
export type GetUploadDocumentsForBorderoSuspenseQueryHookResult = ReturnType<typeof useGetUploadDocumentsForBorderoSuspenseQuery>;
export type GetUploadDocumentsForBorderoQueryResult = Apollo.QueryResult<GetUploadDocumentsForBorderoQuery, GetUploadDocumentsForBorderoQueryVariables>;